import React from 'react'
import { AiOutlineDelete } from 'react-icons/ai'

import { DictionaryDeleteAction } from '../Components/DictionaryDelete/DictionaryDeleteAction'
import { DICTIONARY_DELETE_EVENT } from '../Components/DictionaryDelete/events'

/**
 * Підтвердження видалення запису довідника. Видалити можна й запис з ERP (рішення 2026-11-03),
 * але наступний обмін створить його знову — попереджаємо й підказуємо вимкнути замість видалення.
 */
export const dictionaryDeleteConfirmText = (item: Record<string, any>): string | undefined =>
    item?.['externalCode']
        ? `Запис отримано з ERP (код ${item['externalCode']}): наступний обмін з ERP створить його знову, ` +
          "а дані, де його вказано, лишаться прив'язані до видаленого. Щоб запис лише не пропонувався " +
          'у списках, вимкніть «Активний».'
        : undefined

/**
 * Кнопка «Видалити» в шапці картки запису довідника (ядро дає її лише в меню рядка): видно, коли
 * бекенд дозволяє видалення цього запису (_permissions.delete — адмін і суперадмін).
 */
export const dictionaryDetailButtons = ({ buttons, crudContext, content }: any): void => {
    buttons.deleteRecord = {
        label: 'Видалити',
        icon: React.createElement(AiOutlineDelete, { size: 18 }),
        danger: true,
        size: 'middle',
        priority: 'button',
        sort: 900,
        depStore: { formContext: crudContext.formContext },
        depFn: ({ formContext }: any) =>
            formContext?.values?.id > 0 && formContext?.values?._permissions?.delete === true,
        onClick: () => crudContext.eventManager.emit(DICTIONARY_DELETE_EVENT, {}),
    }
    content.push(<DictionaryDeleteAction key="dictionary-delete-action" crudContext={crudContext} />)
}
